module.exports = __webpack_public_path__ + "static/media/entregarinju3.ed86b0a7.jpg";